import { render, staticRenderFns } from "./SyncConfigTab.vue?vue&type=template&id=3094042a&scoped=true";
import script from "./SyncConfigTab.vue?vue&type=script&lang=js";
export * from "./SyncConfigTab.vue?vue&type=script&lang=js";
import style0 from "./SyncConfigTab.vue?vue&type=style&index=0&id=3094042a&prod&lang=less&scoped=true";

/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js";
var component = normalizer(script, render, staticRenderFns, false, null, "3094042a", null);
export default component.exports;